/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function EasingPlay(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'EasingPlay',
      'aria-hidden': true,
      focusable: false,
      width:  18 * scale,
      height: 18 * scale,
      viewBox: '0 0 18 18',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"fill":"currentColor","fillRule":"evenodd"},createElement('path', {"d":"M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18m0-.783A8.217 8.217 0 1 1 9 .783a8.217 8.217 0 0 1 0 16.434"}),createElement('path', {"d":"M7 13.425V4.91l4.89 4.257z"})))
}
